/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CatalogueResponse } from '../models/CatalogueResponse';
import type { CheckoutResponse } from '../models/CheckoutResponse';
import type { CreditsResponse } from '../models/CreditsResponse';
import type { InvoiceRead } from '../models/InvoiceRead';
import type { PackCheckoutRequest } from '../models/PackCheckoutRequest';
import type { PlanChangePreview } from '../models/PlanChangePreview';
import type { PortalRequest } from '../models/PortalRequest';
import type { SubscriptionCheckoutRequest } from '../models/SubscriptionCheckoutRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BillingService {
    /**
     * Subscription Checkout
     * Start a Stripe Checkout session for one of the plan prices.
     *
     * `price_id` comes from `GET /billing/plans`: a plan is sold at several credit
     * amounts, so the price says both which plan and how many credits. Returns the
     * hosted URL; credits are granted by the webhook once Stripe confirms payment.
     * @param requestBody
     * @returns CheckoutResponse Successful Response
     * @throws ApiError
     */
    public static subscriptionCheckout(
        requestBody: SubscriptionCheckoutRequest,
    ): CancelablePromise<CheckoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/billing/checkout/subscription',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pack Checkout
     * Start a Stripe Checkout session for a one-off credit pack.
     *
     * Returns the hosted URL; the credits land when the webhook confirms payment.
     * @param requestBody
     * @returns CheckoutResponse Successful Response
     * @throws ApiError
     */
    public static packCheckout(
        requestBody: PackCheckoutRequest,
    ): CancelablePromise<CheckoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/billing/checkout/credits',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Portal
     * A Stripe billing-portal URL where the customer manages their subscription.
     * @param requestBody
     * @returns CheckoutResponse Successful Response
     * @throws ApiError
     */
    public static portal(
        requestBody: PortalRequest,
    ): CancelablePromise<CheckoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/billing/portal',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Plans
     * What can be bought: each plan's credit options, the one-off packs and the top-up rate.
     *
     * Read from Stripe, where the credits live in each price's metadata, so adding
     * a credit option or changing a price is a dashboard change. Cached briefly.
     * No brand needed — this is the pricing page.
     * @returns CatalogueResponse Successful Response
     * @throws ApiError
     */
    public static getPlans(): CancelablePromise<CatalogueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/billing/plans',
        });
    }
    /**
     * Get Credits
     * What the brand spends from: its account's allotment, top-ups and plan.
     * @param brandId
     * @returns CreditsResponse Successful Response
     * @throws ApiError
     */
    public static getCredits(
        brandId: number,
    ): CancelablePromise<CreditsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/billing/credits',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Preview Plan Change
     * What switching to `price_id` would cost, so the change can be confirmed.
     *
     * Null means the account has no live subscription: that is a purchase, and Stripe
     * Checkout shows its own total.
     * @param brandId
     * @param priceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static previewPlanChange(
        brandId: number,
        priceId: string,
    ): CancelablePromise<(PlanChangePreview | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/billing/plan-change',
            query: {
                'brand_id': brandId,
                'price_id': priceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Invoices
     * The account's invoices, newest first, read straight from Stripe.
     * @param brandId
     * @returns InvoiceRead Successful Response
     * @throws ApiError
     */
    public static getInvoices(
        brandId: number,
    ): CancelablePromise<Array<InvoiceRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/billing/invoices',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
